import styled from 'styled-components/macro'

const FieldListItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: .5em;
`

export default FieldListItem
